import axios from "axios";

// Fetch Site Details
export const fetchSiteDetails = async (siteId) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/site-details/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { site_id: siteId }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching site details:', error);
    return null;
  }
};


// Handle edit form submit
export const updateSite = async (siteId, editFormData) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    if (!token) {
      throw new Error('No access token found. User might not be authenticated.');
    }

    const response = await axios.put(
      `${process.env.REACT_APP_API_URL}/api/update-site/`,
      editFormData,
      {
        headers: { Authorization: `Bearer ${token}` },
        params: { site_id: siteId }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error updating site:', error);
    throw error; // Re-throw the error to be handled in handleEditSubmit
  }
};

// Get all plant list
export const getPlantList = async () => {
  const token = sessionStorage.getItem('accessToken');
  if (!token) {
    throw new Error('No access token found. User might not be authenticated.');
  }

  try {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/plantlist/`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching plant list:', error);
    throw error; // Re-throw the error to be handled in fetchUserData
  }
};

// Delete Site
export const deleteSite = async (siteId) => {
  const token = sessionStorage.getItem('accessToken');
  if (!token) {
    throw new Error('No access token found. User might not be authenticated.');
  }

  try {
    await axios.post(
      `${process.env.REACT_APP_API_URL}/api/delete-site/`,
      { client_id: siteId },
      { headers: { Authorization: `Bearer ${token}` } }
    );
  } catch (error) {
    console.error('Error deleting site:', error);
    throw error; // Re-throw the error to be handled in handleDeleteConfirm
  }
};

// Add new site
export const registerSite = async (formData) => {
  const token = sessionStorage.getItem('accessToken');
  if (!token) {
    throw new Error('No access token found. User might not be authenticated.');
  }

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/register/`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },

      }
    );
    return response; // Return response so we can handle it in handleSubmit
  } catch (error) {
    throw error; // Re-throw the error to be handled in handleSubmit
  }
};

export const total_grid_consume = async (siteId, formattedDate) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/total-grid-consume/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: siteId,
        date: formattedDate,
      }
    });
    return response;
  } catch (err) {
    throw err; // Re-throw the error to be caught in handleSubmit
  }
};

export const total_solar_generated = async (siteId, formattedDate) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/total-solar-generated/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: siteId,
        date: formattedDate,
      }
    });
    return response;
  } catch (err) {
    throw err; // Re-throw the error to be caught in handleSubmit
  }
};

export const total_grid_export = async (siteId, formattedDate) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/total-grid-export/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: siteId,
        date: formattedDate,
      }
    });
    return response;
  } catch (err) {
    throw err; // Re-throw the error to be caught in handleSubmit
  }
};

export const accumulated_solar = async (siteId, formattedDate) => {
  try {
    const token = sessionStorage.getItem('accessToken');
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/accumulated-solar/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        site_id: siteId,
        date: formattedDate,
      }
    });
    return response;
  } catch (err) {
    throw err; // Re-throw the error to be caught in handleSubmit
  }
};